





















import {Component, Vue, Model, Prop} from "vue-property-decorator";
import request from "@/util/request";
import _ from 'lodash';


@Component
export default class excelExport extends Vue {
    @Model("change", {type: Object})
    readonly value !: {
        name: string,
        id: number,
    };


    @Prop()
    parentId!: string;
    @Prop()
    name!: string;

    excel = {
        id: null,
        name: null,
    }

    created() {

    }

    get excelId() {
        return this.parentId;
    }


    get excelName() {
        return this.name;
    }

    startCreateExcel() {

        if (this.excelId) {
            this.HtmlExportToExcel(this.excelId);
        }
    }

    HtmlExportToExcel(tableId) {

        let ieVersion = this.IEVersion();
        if (ieVersion == -1) {
            //不是IE
            this.HtmlExportToExcelForEntire(tableId, this.excelName);
        } else {
            //ie浏览器不够顺畅.还是不推荐用IE的..
            this.HtmlExportToExcelForIE(tableId);
        }
    }

    HtmlExportToExcelForIE(tableid) {
        try {
            var curTbl = document.getElementById(tableid);
            // this.$parent.$refs[tableid];

            var oXL;
            try {
                oXL = new ActiveXObject("Excel.Application"); //创建AX对象excel
            } catch (e) {
                let message = "无法启动Excel!\n\n如果您确信您的电脑中已经安装了Excel，" + "那么请调整IE的安全级别。\n\n具体操作：\n\n" + "工具 → Internet选项 → 安全 → 自定义级别 → 对没有标记为安全的ActiveX进行初始化和脚本运行 → 启用";

                alert(message);
                return false;
            }
            var oWB = oXL.Workbooks.Add(); //获取workbook对象
            var oSheet = oWB.ActiveSheet;//激活当前sheet
            //@ts-ignore
            var sel = document.body.createTextRange();
            sel.moveToElementText(curTbl); //把表格中的内容移到TextRange中
            try {
                sel.select(); //全选TextRange中内容
            } catch (e1) {
                e1.description
            }
            sel.execCommand("Copy");//复制TextRange中内容
            oSheet.Paste();//粘贴到活动的EXCEL中
            oXL.Visible = true; //设置excel可见属性
            var fname = oXL.Application.GetSaveAsFilename(this.excelName + ".xls", "Excel Spreadsheets (*.xls), *.xls");
            oWB.SaveAs(fname);
            oWB.Close();
            oXL.Quit();
        } catch (e) {
            let error = e.description;
            alert(error);
        }
    }


    HtmlExportToExcelForEntire(tableId, name) {

        // let table = this.$parent.$refs[tableId];

        let table = document.getElementById(tableId);

        //@ts-ignore
        let {href} = this.getHtmlToExcelHrefZh(table.innerHTML, null);

        //@ts-ignore
        document.getElementById("dlink").href = href;
        //@ts-ignore
        document.getElementById("dlink").download = this.excelName + ".xls";
        //@ts-ignore
        document.getElementById("dlink").click();
    }

    getBase64(s) {
        return window.btoa(unescape(encodeURIComponent(s)));
    }


    IEVersion() {
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
        var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
        var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
        var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
        if (isIE) {
            var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
            reIE.test(userAgent);
            var fIEVersion = parseFloat(RegExp["$1"]);
            if (fIEVersion == 7) {
                return 7;
            } else if (fIEVersion == 8) {
                return 8;
            } else if (fIEVersion == 9) {
                return 9;
            } else if (fIEVersion == 10) {
                return 10;
            } else {
                return 6;//IE版本<=7
            }
        } else if (isEdge) {
            return 'edge';//edge
        } else if (isIE11) {
            return 11; //IE11
        } else {
            return -1;//不是ie浏览器
        }
    }


    getHtmlToExcelHrefZh(tableHtml, workSheetName) {
        let ctx = {worksheet: workSheetName || 'Worksheet', table: tableHtml};

        let uri = 'data:application/vnd.ms-excel;base64,';


        let excelFile = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:x='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'>";

        // excelFile += "<head><meta charset='UTF-8'><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head>";
        excelFile += "<head><meta charset='UTF-8'><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>" + ctx.worksheet + "</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head>";

        excelFile += "<body><table>";

        excelFile += tableHtml;

        excelFile += "</table></body>";

        excelFile += "</html>";

        let href = uri + this.getBase64(excelFile);
        return {href: href};
    }

}
